module.exports = __webpack_public_path__ + "img/full-02.9bc9c88f.png";